// extracted by mini-css-extract-plugin
export default {"langGroup":"styles_langGroup__yzf0q","Sub":"styles_Sub__dc4g4","Disabled":"styles_Disabled__iXRsS","languagesList":"styles_languagesList__iWGOz"};